export default __webpack_public_path__ + "assets/thermometer-glass.19868528.svg";